import axios from './axios';

function getByChildId(childId) {
    return axios
        .get(`/api/assignments/child/${childId}/active`)
        .then(data => data.assignments);
}

function getById(id) {
    return axios
        .get(`/api/assignments/${id}`);
}

export default {
    getByChildId,
    getById
}